import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { BookOpen, ChevronLeft, Clock } from 'lucide-react'
import { Card, CardContent, Button } from '@/components/ui'

export function LearnHub() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      {/* Back link */}
      <Link
        to="/studio"
        className="inline-flex items-center gap-2 text-[var(--color-kids-text-muted)] hover:text-[var(--color-kids-text)] transition-colors mb-6"
      >
        <ChevronLeft className="w-5 h-5" />
        <span className="font-medium">Writing Studio</span>
      </Link>

      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-10"
      >
        <div className="w-20 h-20 mx-auto rounded-full bg-[var(--color-kids-secondary)]/10 flex items-center justify-center mb-6">
          <BookOpen className="w-10 h-10 text-[var(--color-kids-secondary)]" />
        </div>
        <h1 className="font-display text-[var(--font-size-kid-2xl)] font-bold text-[var(--color-kids-text)] mb-2">
          Learning Path
        </h1>
        <p className="text-[var(--color-kids-text-muted)] text-lg">
          Guided lessons to help you become a better writer
        </p>
      </motion.div>

      {/* Coming soon card */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <Card className="border-dashed border-2 border-[var(--color-kids-border)]">
          <CardContent className="p-8 text-center">
            <div className="w-16 h-16 mx-auto rounded-full bg-[var(--color-kids-accent)]/10 flex items-center justify-center mb-6">
              <Clock className="w-8 h-8 text-[var(--color-kids-accent)]" />
            </div>
            <h2 className="font-display text-xl font-bold text-[var(--color-kids-text)] mb-3">
              Coming Soon!
            </h2>
            <p className="text-[var(--color-kids-text-muted)] mb-6 max-w-md mx-auto">
              We're working on fun lessons about story structure, character building,
              dialogue writing, and more. Check back soon!
            </p>
            <Link to="/studio/write">
              <Button variant="secondary">
                Try Free Writing Instead
              </Button>
            </Link>
          </CardContent>
        </Card>
      </motion.div>

      {/* Preview of upcoming lessons */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="mt-8"
      >
        <h3 className="font-display font-bold text-[var(--color-kids-text)] mb-4">
          What's Coming
        </h3>
        <div className="grid sm:grid-cols-2 gap-4">
          {[
            { emoji: '🎬', title: 'Strong Beginnings', desc: 'Hook your readers from the start' },
            { emoji: '🎭', title: 'Character Voices', desc: 'Make characters sound unique' },
            { emoji: '💬', title: 'Dialogue Tips', desc: 'Write conversations that pop' },
            { emoji: '🎯', title: 'Show, Don\'t Tell', desc: 'Paint pictures with words' },
          ].map((lesson) => (
            <Card key={lesson.title} className="opacity-60">
              <CardContent className="p-4 flex items-center gap-4">
                <span className="text-2xl">{lesson.emoji}</span>
                <div>
                  <h4 className="font-display font-bold text-[var(--color-kids-text)]">
                    {lesson.title}
                  </h4>
                  <p className="text-sm text-[var(--color-kids-text-muted)]">
                    {lesson.desc}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </motion.div>
    </div>
  )
}
